/* eslint-disable react/jsx-key */
import Ecid from "components/Ecid";
import Loading from "components/Loading/Loading";
import WithTracker from "components/Tracker";
import {
  WithCategoryTracker,
  WithIconTracker,
  WithProductTracker,
} from "components/Tracker/Tracker";
import LandingPage from "pages/LandingPage";
import { lazy, Suspense } from "react";
import { FormattedMessage } from "react-intl";
import { CATEGORY, COLLECTION } from "./const";

const Home = lazy(() => import("../pages/Home"));
const Category = lazy(() => import("../pages/Category"));
const Icon = lazy(() => import("../pages/Icon"));
const ProductDetail = lazy(() => import("../pages/ProductDetail"));
const Cart = lazy(() => import("../pages/Cart"));
const PersonalCenter = lazy(() => import("../pages/PersonalCenter"));
const MyOrder = lazy(() => import("../pages/MyOrder"));
const MySettings = lazy(() => import("../pages/MySettings"));
const OrderForm = lazy(() => import("../pages/OrderForm"));
const OrderRefund = lazy(() => import("../pages/OrderRefund"));
const FAQ = lazy(() => import("../pages/FAQ"));
const OrderDetailPage = lazy(() => import("../pages/OrderDetailPage"));

const routes = (basename = "") => [
  {
    path: basename + "/",
    exact: true,
    element: <LandingPage />,
  },
  {
    path: basename + "/home",
    exact: true,
    element: (
      <WithTracker ga="view_items">
        <WithTracker ga="view_home">
          <Suspense fallback={<Loading />}>
            <Ecid>
              <Home />
            </Ecid>
          </Suspense>
        </WithTracker>
      </WithTracker>
    ),
  },
  {
    path: basename + "/category/:id/:status",
    element: (
      <WithTracker ga="product_catagory">
        <WithCategoryTracker ga="view_category">
          <Suspense fallback={<Loading />}>
            <Category />
          </Suspense>
        </WithCategoryTracker>
      </WithTracker>
    ),
    displayMenu: true,
    name: (
      <div className="intl-text">
        <FormattedMessage id="menu_category" defaultMessage="Category" />
      </div>
    ),
    key: CATEGORY,
    getTitle: (title) => title,
    children: {
      path: (item) => {
        return `/category/${item.referenceId}/list`;
      },
      key: "categories",
      showThVersion: true,
    },
    isThTitle: true,
  },
  {
    path: basename + "/category/:id/tag/:tagId",
    element: (
      <WithTracker ga="product_catagory">
        <WithCategoryTracker ga="view_catagory">
          <Suspense fallback={<Loading />}>
            <Category />
          </Suspense>
        </WithCategoryTracker>
      </WithTracker>
    ),
  },
  {
    path: basename + "/product/:id",
    element: (
      <WithProductTracker ga="view_item_liff">
        <Suspense fallback={<Loading />}>
          <ProductDetail />
        </Suspense>
      </WithProductTracker>
    ),
  },
  {
    path: basename + "/icons/:id/:status",
    element: (
      <WithTracker ga="product_catagory">
        <WithIconTracker ga="view_icon">
          <Suspense fallback={<Loading />}>
            <Icon />
          </Suspense>
        </WithIconTracker>
      </WithTracker>
    ),
    displayMenu: true,
    name: (
      <div className="intl-text">
        <FormattedMessage id="menu_collection" defaultMessage="Collection" />
      </div>
    ),
    key: COLLECTION,
    getTitle: (title) => title,
    children: {
      path: (item) => {
        return `/icons/${item.referenceId}/list`;
      },
      key: "collections",
    },
    isThTitle: true,
  },
  {
    path: basename + "/cart",
    element: (
      <WithTracker ga="cart">
        <Suspense fallback={<Loading />}>
          <Cart />
        </Suspense>
      </WithTracker>
    ),
  },
  {
    path: basename + "/order-form",
    element: (
      <WithTracker ga="order_form_liff">
        <Suspense fallback={<Loading />}>
          <Ecid>
            <OrderForm />
          </Ecid>
        </Suspense>
      </WithTracker>
    ),
  },
  // {
  //   path: basename + "/order-refund/:id",
  //   element: (
  //     <WithTracker ga="order_refund_liff">
  //       <Suspense fallback={<Loading />}>
  //         <OrderRefund />
  //       </Suspense>
  //     </WithTracker>
  //   ),
  // },
  // {
  //   path: basename + "/account",
  //   element: (
  //     <WithTracker ga="configs">
  //       <Suspense fallback={<Loading />}>
  //         <PersonalCenter />
  //       </Suspense>
  //     </WithTracker>
  //   ),
  // },
  {
    path: basename + "/orders",
    element: (
      <WithTracker ga="invoice">
        <Suspense fallback={<Loading />}>
          <MyOrder />
        </Suspense>
      </WithTracker>
    ),
  },
  {
    path: basename + "/order/:id",
    element: (
      <WithTracker ga="order_detail">
        <Suspense fallback={<Loading />}>
          <OrderDetailPage />
        </Suspense>
      </WithTracker>
    ),
  },
  {
    path: basename + "/settings",
    element: (
      <WithTracker ga="configs">
        <Suspense fallback={<Loading />}>
          <MySettings />
        </Suspense>
      </WithTracker>
    ),
  },
  {
    path: basename + "/FAQ",
    element: (
      <WithTracker ga="faq">
        <Suspense fallback={<Loading />}>
          <FAQ />
        </Suspense>
      </WithTracker>
    ),
  },
];

export default routes;
